var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-loader"},[_c('div',{staticClass:"login-loader__centered"},[_c('div',{staticClass:"login-loader__logo"}),_c('div',{staticClass:"login-loader__text"},[_c('span',{staticClass:"el-icon-loading"}),_vm._v(" "+_vm._s(_vm.$t(`auth.loader_text`))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }